/*!
 * Legends Distillery - Big Thirst Storefront Loader
 *
 * Stable loader for legendsdistillery.us. Install once on the Buy Online page
 * and let it fetch the current config with a cache-busting query string.
 */

(function () {
  'use strict';

  if (window.__BT_LEGENDS_LOADER_LOADED) return;
  window.__BT_LEGENDS_LOADER_LOADED = true;

  var DEFAULT_CONFIG_SRC = 'https://checkout-6.bigthirst.com/cdn/shop/files/legends-config.js';
  var configSrc = window.__BT_LEGENDS_CONFIG_SRC || DEFAULT_CONFIG_SRC;
  var configVersion = window.__BT_LEGENDS_CONFIG_VERSION || String(Date.now());
  var separator = configSrc.indexOf('?') === -1 ? '?' : '&';
  var head = document.head || document.documentElement;
  var script = document.createElement('script');

  script.src = configSrc + separator + 'v=' + encodeURIComponent(configVersion);
  script.async = false;
  script.setAttribute('data-bt-legends-config', 'true');
  head.appendChild(script);
})();
